export default [
  {
    path: '/exam/index',
    name: 'index',
    component: () => import('@/views/exam/index'),
    meta: {
      title: '学考题库'
    }
  },
  {
    path: '/exam/paper',
    name: 'paper',
    component: () => import('@/views/exam/paper'),
    meta: {
      title: '做题'
    }
  },
  {
    path: '/exam/rank',
    name: 'rank',
    component: () => import('@/views/exam/rank'),
    meta: {
      title: '排名'
    }
  },
  {
    path: '/exam/log',
    name: 'log',
    component: () => import('@/views/exam/log'),
    meta: {
      title: '日志'
    }
  },
  {
    path: '/exam/record',
    name: 'record',
    component: () => import('@/views/exam/record'),
    meta: {
      title: '记录'
    }
  },
  {
    path: '/exam/pastExam',
    name: 'pastExam',
    component: () => import('@/views/exam/pastExam'),
    meta: {
      title: '历年真题'
    }
  },
  {
    path: '/exam/featExam',
    name: 'featExam',
    component: () => import('@/views/exam/featExam'),
    meta: {
      title: '精选练习'
    }
  },
  {
    path: '/exam/daily',
    name: 'daily',
    component: () => import('@/views/exam/daily'),
    meta: {
      title: '每日打卡'
    },
  },
  {
    path: '/exam/store',
    name: 'store',
    component: () => import('@/views/exam/store'),
    meta: {
      title: '错题·收藏'
    },
  },
  {
    path: '/exam/answerRank',
    name: 'answerRank',
    component: () => import('@/views/exam/answerRank'),
    meta: {
      title: '答题排行榜'
    },
  },
  {
    path: '/exam/result',
    name: 'result',
    component: () => import('@/views/exam/result'),
    meta: {
      title: '我的成绩'
    }
  },
  {
    path: '/exam/paperPractice',
    name: 'paperPractice',
    component: () => import('@/views/exam/paperPractice'),
    meta: {
      title: '做题'
    }
  },
  {
    path: '/exam/paperShare',
    name: 'paperShare',
    component: () => import('@/views/exam/paperShare'),
    meta: {
      title: '做题'
    }
  },
  {
    path: '/exam/paperShareApp',
    name: 'paperShareApp',
    component: () => import('@/views/exam/paperShareApp'),
    meta: {
      title: '分享'
    }
  },
  {
    path: '/exam/paperPreview',
    name: 'paperPreview',
    component: () => import('@/views/exam/paperPreview'),
    meta: {
      title: '预览'
    }
  },
  {
    path: '/exam/paperCollect',
    name: 'paperCollect',
    component: () => import('@/views/exam/paperCollect'),
    meta: {
      title: '详情'
    }
  },
  {
    path: '/exam/default',
    name: 'default',
    component: () => import('@/views/exam/default'),
    meta: {
      title: '2024学考题库·高考直通车'
    }
  },
]
